/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-22.
 */
import React, { Component } from 'react';
import { Snackbar } from 'material-ui';
import PropTypes from 'prop-types';

class SnackbarWrapper extends Component {

    static SUCCESS = 'green';
    static ERROR = 'red';
    static WARNING = 'yellow';
    static INFO = 'black';

    constructor(props){
      super(props);
      this.state = {
        status: {...this.props}
      };
    }

    render() {
        const { open, message, autoHideDuration, type } = this.props;

        return (
            <Snackbar
                bodyStyle={{
                    top: 0,
                    bottom: 'auto',
                    backgroundColor: type
                }}
                open={this.state.status.open}
                message={message}
                autoHideDuration={autoHideDuration}
                onRequestClose={() =>  this.setState({status: {...this.props, open:false}})}
            />
        );
    }
}

SnackbarWrapper.propTypes = {
    open: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    autoHideDuration: PropTypes.number.isRequired,
    type: PropTypes.oneOf([
        SnackbarWrapper.SUCCESS,
        SnackbarWrapper.ERROR,
        SnackbarWrapper.WARNING,
        SnackbarWrapper.INFO]
    )
};

SnackbarWrapper.defaultProps = {
    open: true,
    message: 'Sin Mensaje',
    errorMessage: true,
    autoHideDuration: 5000,
    type: SnackbarWrapper.INFO
};

export default SnackbarWrapper;



// WEBPACK FOOTER //
// ./components/widgets/snackbar.js